import { call, takeEvery } from 'redux-saga/effects';
import urls from 'config/urls';
import { ApplePayConstants } from 'constants/applePay';
import { request } from 'components/Fetch';

function* validateMerchant(action) {
  yield call(request({
    type: ApplePayConstants.VALIDATE_MERCHANT,
    method: 'POST',
    url: urls.validateMerchant(),
  }), action);
}

function* sendQuickpayText(action) {
  yield call(request({
    type: ApplePayConstants.SEND_QUICKPAY_TEXT,
    method: 'POST',
    url: urls.sendQuickpayText(action.payload.loanId),
  }), action);
}

const applePaySaga = function* () {
  yield takeEvery(ApplePayConstants.VALIDATE_MERCHANT, validateMerchant);
  yield takeEvery(ApplePayConstants.SEND_QUICKPAY_TEXT, sendQuickpayText);
};

export default applePaySaga;
